import { useEffect } from 'react';
import { createSocket } from '../utils/socket/socket.instance';
import { bindSocketEvents } from '../utils/socket/socket.events';
import { connectSocket, destroySocket } from '../utils/socket/socket.control';

export const useSocket = enabled => {
  useEffect(() => {
    if (!enabled) {
      destroySocket();
      return undefined;
    }

    const socket = createSocket();
    bindSocketEvents(socket);
    connectSocket();

    return () => {
      destroySocket();
    };
  }, [enabled]);
};
